import React from 'react';
import { motion } from 'framer-motion';
import { cardHover, fadeInUp } from '../../utils/animations';

const Card = ({ 
  children, 
  className = '',
  hoverable = true,
  delay = 0 
}) => {
  
  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6, delay }
    }
  };
  
  return (
    <motion.div
      className={`bg-white rounded-lg overflow-hidden ${className}`}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={cardVariants}
      whileHover={hoverable ? "hover" : ""}
      animate="rest"
      {...(hoverable && cardHover)}
    >
      {children}
    </motion.div>
  );
};

// Card subcomponents for better composition
Card.Image = ({ src, alt, className = '' }) => (
  <div className={`overflow-hidden ${className}`}>
    <motion.img 
      src={src} 
      alt={alt} 
      className="w-full h-full object-cover"
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.4 }}
    />
  </div>
);

Card.Content = ({ children, className = '' }) => (
  <div className={`p-6 ${className}`}>
    {children}
  </div>
);

Card.Title = ({ children, className = '' }) => (
  <h3 className={`text-2xl font-serif text-dark mb-3 ${className}`}>
    {children}
  </h3>
);

Card.Description = ({ children, className = '' }) => (
  <p className={`text-dark-light leading-relaxed ${className}`}>
    {children}
  </p>
);

export default Card;